import { z } from "zod";

export const NotificationSubjectSchema = z.enum([
  "invoice",
  "sweeps",
  "transfer",
]);

export type NotificationSubject = z.infer<typeof NotificationSubjectSchema>;

export const NotificationTypeSchema = z.enum(["email", "sms"]);

export type NotificationType = z.infer<typeof NotificationTypeSchema>;

export const NotificationInfoItemSchema = z.object({
  notification_type: z.string(),
  notification_value: z.string(),
  process_flow_step: z.string(),
  active: z.boolean(),
});

export type NotificationInfoItem = z.infer<typeof NotificationInfoItemSchema>;

export const NotificationInfoSchema = z.object({
  notification_info: z.array(NotificationInfoItemSchema),
});

export type NotificationInfo = z.infer<typeof NotificationInfoSchema>;

export const NotificationInfoResponseSchema = z.array(NotificationInfoSchema);

export type NotificationInfoResponse = z.infer<
  typeof NotificationInfoResponseSchema
>;

// Add notification request payload
export interface AddNotificationPayload {
  notification_type: NotificationType;
  notification_value: string;
  process_flow_step: string;
  active: boolean;
}
